!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.mainDetails = this.querySelector("[data-details]"), this.tabPanelsContainer = this.querySelector("[data-tab-panels]");
      const t = this.closest("product-wrapper") || document;
      this.triggers = t.querySelectorAll("[data-tab-trigger]"), this.triggers.forEach(t => {
        t.addEventListener("click", t => this.onTriggerClick(t));
      });
    }
    onTriggerClick(t) {
      const e = this.querySelector("teleport-details");
      e && "function" == typeof e.open && !this.mainDetails.open ? e.open() : e || this.mainDetails.open || (this.mainDetails.open = !0);
      const s = t.currentTarget.dataset.tabTrigger, i = this.tabPanelsContainer?.querySelector(`details[data-tab-id="${s}"]`);
      this.openTab(i);
    }
    openTab(t) {
      t && t.setAttribute("open", "");
    }
  }
  customElements.get("product-details") || customElements.define("product-details", t);
}();